import {
  IsEnum,
  IsNumber,
  IsOptional,
  IsString,
  IsUUID,
  Min,
  Max,
  MaxLength,
} from 'class-validator'
import { ApiPropertyOptional } from '@nestjs/swagger'
import { Transform } from 'class-transformer'
import { PedagogicContentState } from '../../../enums/content.enum'
import {
  MAX_TEACHING_DESCRIPTION_LENGTH,
  MIN_WORKLOAD,
  MAX_WORKLOAD,
  MIN_WEIGHT,
  MAX_WEIGHT,
} from '../../../constants/teaching.constants'

const toNumber = ({ value }: { value: any }) => {
  if (value === '' || value === null || value === undefined) return undefined
  return Number(value)
}

const toStringOrUndefined = ({ value }: { value: any }) => {
  if (value === '' || value === null) return undefined
  return value
}

export class UpdateTeachingDto {
  @ApiPropertyOptional({ description: 'ID de la matière', type: 'string' })
  @IsOptional()
  @IsUUID('4')
  subjectExternalId?: string

  @ApiPropertyOptional({ description: 'ID de la classe', type: 'string' })
  @IsOptional()
  @Transform(toStringOrUndefined)
  @IsUUID('4')
  classId?: string

  @ApiPropertyOptional({ description: 'ID du groupe', type: 'string' })
  @IsOptional()
  @Transform(toStringOrUndefined)
  @IsUUID('4')
  groupId?: string

  @ApiPropertyOptional({ description: "ID de l'établissement", type: 'string' })
  @IsOptional()
  @Transform(toStringOrUndefined)
  @IsUUID('4')
  establishmentId?: string

  @ApiPropertyOptional({ description: 'État', enum: PedagogicContentState })
  @IsOptional()
  @IsEnum(PedagogicContentState)
  state?: PedagogicContentState

  @ApiPropertyOptional({ description: 'ID de la version de programme', type: 'string' })
  @IsOptional()
  @Transform(toStringOrUndefined)
  @IsUUID('4')
  programVersionId?: string

  @ApiPropertyOptional({ description: "ID de l'année scolaire", type: 'string' })
  @IsOptional()
  @IsUUID('4')
  schoolYearId?: string

  @ApiPropertyOptional({ description: 'Description', type: 'string' })
  @IsOptional()
  @IsString()
  @MaxLength(MAX_TEACHING_DESCRIPTION_LENGTH)
  description?: string

  @ApiPropertyOptional({ description: 'Poids dans la progression', type: Number })
  @IsOptional()
  @Transform(toNumber)
  @IsNumber()
  @Min(MIN_WEIGHT)
  @Max(MAX_WEIGHT)
  weightInProgression?: number

  @ApiPropertyOptional({ description: 'Charge de travail estimée', type: Number })
  @IsOptional()
  @Transform(toNumber)
  @IsNumber()
  @Min(MIN_WORKLOAD)
  @Max(MAX_WORKLOAD)
  estimatedWorkload?: number
}
